import { Inject, Pipe, PipeTransform } from '@angular/core';
import { SecureImage } from '@miq/utils';
import { ReportRecord } from '../../models/report.model';
import { NavigationRouteFunctionPPT } from '../../models/template.model';
import { TEMPLATE_CONFIGURATIONS } from '../templates/template-display-fn.const';
import { CbreLogger, CbreLoggerToken } from '@cbre/logger';

/**
 * Get **record route function** from the template configurations, based on the
 * template id. If found, it executes the function, passing the provided record.
 */
@Pipe({
  name: 'reportRecordRouteFn',
  standalone: false,
})
export class ReportRecordRouteFnPipe implements PipeTransform {
  constructor(@Inject(CbreLoggerToken) private readonly logger: CbreLogger) {}
  transform(
    record: { [attr: string]: any },
    settings: { templateId: number; entity: string }
  ): string | string[] | SecureImage {
    const { recordRouteFn } = TEMPLATE_CONFIGURATIONS[settings.templateId];
    if (recordRouteFn == null) {
      // if no record route function is found, it could mean that we do not have
      // it configured in the template-display-fn.const file for the template in
      // question.
      this.logger.warn(`No Record Route Function for template with id: ${settings.templateId}`);
      return [];
    }

    // check if route function is an object or directly a function
    let routeFn = recordRouteFn as NavigationRouteFunctionPPT;
    if (typeof recordRouteFn === 'object') {
      const { entity } = settings;
      if (entity == null) {
        // if no entity is found, it could mean that the view template (HTML)
        // does not have an entity configured as part of the settings argument
        // of this pipe.
        this.logger.error(`No entity configured for route function of template with id: ${settings.templateId}`);
        return [];
      }

      routeFn = routeFn[entity] || recordRouteFn[entity];
    }

    return routeFn(record as ReportRecord);
  }
}
